import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    team: []
};

const team1Slice = createSlice({
    name: 'team1',
    initialState,
    reducers: {
        addPokemon: (state, action) => {
            if (!state.team.includes(action.payload) && state.team.length < 6) {
                state.team.unshift(action.payload);
            }
        },
        removePokemon: (state, action) => {
            const nameToRemove = action.payload;
            const index = state.team.indexOf(nameToRemove);
            if (index !== -1) {
                state.team.splice(index, 1);

            }
        },
        removeAll: (state) => {
            state.team = [];
        },
        shuffle: (state) => {
            state.team.sort(() => Math.random() - 0.1);

        }
    }
});

export const { addPokemon, removePokemon, removeAll,shuffle } = team1Slice.actions;
export default team1Slice.reducer;
